import { useTranslation } from 'react-i18next';
import { Quote } from 'lucide-react';

const ITEM_KEYS = ['one', 'two', 'three', 'four'] as const;

export function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="border-t border-linen bg-paper/40">
      <div className="max-w-editorial mx-auto px-6 sm:px-10 py-20">
        <div className="grid grid-cols-12 gap-6 mb-12 items-end">
          <div className="col-span-12 md:col-span-8">
            <span className="editorial-label">{t('testimonials.kicker')}</span>
            <h2 className="font-display text-4xl sm:text-5xl italic mt-3 text-ink">
              {t('testimonials.title')}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4">
            <div className="editorial-rule mb-3" />
            <p className="font-body text-sm text-ink-soft leading-relaxed">
              {t('testimonials.subtitle')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-12">
          {ITEM_KEYS.map((key) => (
            <figure key={key} className="relative">
              <Quote className="w-7 h-7 text-brass mb-4" aria-hidden="true" />
              <blockquote className="font-display italic text-xl sm:text-2xl leading-snug text-ink">
                « {t(`testimonials.items.${key}.quote`)} »
              </blockquote>
              <figcaption className="mt-5 flex items-baseline gap-3">
                <span className="font-display text-base text-ink">
                  {t(`testimonials.items.${key}.name`)}
                </span>
                <span className="editorial-label text-ink-soft">
                  {t(`testimonials.items.${key}.city`)}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
